import { Card } from '@material-tailwind/react'
import React from 'react'
import AIcon from '../../../components/partials/AIcon'

export default function SmallCard({ v }) {

    const handleClick = () =>{

    }
    return (
        <Card className="bg-white shadow-lg shadow-gray-200 rounded-2xl p-4 mb-5 border border-blue-gray-50/10 cursor-pointer hover:bg-green-50/50 hover:border-green-600" style={{ direction: 'rtl' }} onClick={v.onclick}>
            <div className="flex items-center">
                <div className={`inline-flex flex-shrink-0 justify-center items-center w-12 h-12 text-white rounded-lg shadow-md shadow-gray-300 ${v?.icon?.className}`}>
                    <AIcon name={v?.icon?.name} size={30} />
                </div>
                <div className="flex-shrink-0 mx-3">
                    <span className="text-2xl font-bold leading-none text-gray-900">{v?.amount}</span>
                    <h3 className="text-lg font-normal text-gray-500 amiriB">{v?.name}</h3>
                </div>
                <div className="flex flex-1 justify-end items-center mr-5 w-0 text-base font-bold">
                    <span>  امروز:  </span>
                    <div className="flex items-center mr-1 text-base font-bold text-green-500">
                        {v?.persantage}
                        <AIcon name="arrow-up-outline" />
                    </div>
                </div>

            </div>
        </Card>
    )
}
